import { useSuspenseQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/api/axios'
import { createQueryKey } from '@/api/query-keys'
import { CapitalStructureTotalsPayload } from '../types/totals'
import { PeriodTypeQuery, PeriodTypeView } from '@/types'

// Query keys
const CAPITAL_STRUCTURE_TOTALS_BASE_KEY = [`capital-structure`, `totals`]

export const CAPITAL_STRUCTURE_TOTALS_KEY = createQueryKey({
  baseKey: CAPITAL_STRUCTURE_TOTALS_BASE_KEY,
  keys: [`results`]
})

// Get totals endpoint
type GetTotalsParams = {
  financial_model_id: string
  type: PeriodTypeQuery
  view: PeriodTypeView
}

const getTotals = async ({ financial_model_id, type, view }: GetTotalsParams) => {
  const { data } = await axiosInstance.get<CapitalStructureTotalsPayload>(`/financial-models/${financial_model_id}/capital-structure/totals`, {
    params: { type, view }
  })
  return data
}

export const useGetTotals = ({ financial_model_id, type, view }: GetTotalsParams) =>
  useSuspenseQuery({
    queryKey: CAPITAL_STRUCTURE_TOTALS_KEY.concat([financial_model_id, type, view]),
    queryFn: () => getTotals({ financial_model_id, type, view })
  })
